/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Filter_Not_ApprovedInputs */

const vi_tea_purchase_filter_not_approved = /** @type {(inputs: Tea_Purchase_Filter_Not_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa phê duyệt`)
};

/**

* @param {Tea_Purchase_Filter_Not_ApprovedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_filter_not_approved = /** @type {((inputs?: Tea_Purchase_Filter_Not_ApprovedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Filter_Not_ApprovedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_filter_not_approved(inputs)
});